export default "__VITE_ASSET__8464b987__"